// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-table-row {
  height: 10px;
  max-height: 1rem;
  cursor: pointer;
}.ant-table-row:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}.ant-table-row {
  transition: background-color 0.3s;
  height: 30px;
}

.table-filter-chips {
  display: flex;
  height: 2.25rem;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.entities-table .ant-table-content {
  overflow-y: auto !important;
  height: calc(100vh - 316px) !important;
}

.billing-table .ant-table-content {
  overflow-y: auto !important;
  height: calc(100vh - 500px) !important;
}

.table-container {
  position: relative;
}

.pagination-container {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
  border-top: 1px solid #ddd;
  padding: 10px;
  z-index: 1000;
}

.ant-table-wrapper .ant-table-thead > tr > th {
  height: 2.75rem;
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}

.ant-table-content .ant-table-thead > tr > th {
  position: sticky;
  top: 0;
  z-index: 2;
}

th.ant-table-cell::before {
  display: none;
}

.table-container {
  height: fit-content;
  max-height: fit-content;
  width: 100%;
}

.ant-pagination .ant-pagination-item-active {
  display: flex;
  align-items: center;
  border-style: none;
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.ant-pagination .ant-pagination-item-active a {
  margin-left: 0.375rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}

.ant-table-wrapper .ant-table-pagination a {
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}

.ant-spin-nested-loading > div > .ant-spin {
  background-color: white !important;
}

.custom-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.custom-pagination .ant-pagination-total-text {
  order: -1;
  margin-right: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/Table/TableComponent.scss"],"names":[],"mappings":"AACE;EAAA,YAAA;EAAA,gBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CADF;EAEE,iCAAA;EACA,YAAA;AACF;;AAKE;EAAA,aAAA;EAAA,eAAA;EAAA,eAAA;EAAA,mBAAA;EAAA;AAAA;;AAKF;EACE,2BAAA;EACA,sCAAA;AAHF;;AAMA;EACE,2BAAA;EACA,sCAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,aAAA;EACA,aAAA;AAHF;;AAOE;EAAA,eAAA;EAAA,kBAAA;EAAA,4DAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA;AAAA;;AAGF;EACE,gBAAA;EACA,MAAA;EACA,UAAA;AAHF;;AAOE;EAAA;AAAA;;AAIA;EAAA,mBAAA;EAAA,uBAAA;EAAA;AAAA;;AAIA;EAAA,aAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA;AAAA;AAGE;EAAA,qBAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA;AAAA;;AAMA;EAAA,gBAAA;EAAA,oBAAA;EAAA;AAAA;;AAIJ;EACE,kCAAA;AANF;;AAQA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AALF;;AAOA;EACE,SAAA;EACA,kBAAA;AAJF","sourcesContent":[".ant-table-row {\n  @apply cursor-pointer hover:bg-gray-50 h-[10px] max-h-4;\n  transition: background-color 0.3s;\n  height: 30px;\n}\n\n// Fixed height whether or not any chips are present, so adding or clearing a filter\n// never shifts the table up or down.\n.table-filter-chips {\n  @apply flex h-9 flex-wrap items-center gap-2;\n}\n\n// Shortened by the height of the chip row above it, so the page still fits without the\n// table resizing as chips come and go.\n.entities-table .ant-table-content {\n  overflow-y: auto !important;\n  height: calc(100vh - 316px) !important;\n}\n\n.billing-table .ant-table-content {\n  overflow-y: auto !important;\n  height: calc(100vh - 500px) !important;\n}\n\n.table-container {\n  position: relative;\n}\n\n.pagination-container {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  background: #fff;\n  border-top: 1px solid #ddd;\n  padding: 10px;\n  z-index: 1000;\n}\n\n.ant-table-wrapper .ant-table-thead > tr > th {\n  @apply text-gray-600 text-xs bg-gray-50 h-11 font-medium;\n}\n\n.ant-table-content .ant-table-thead > tr > th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\nth.ant-table-cell::before {\n  @apply hidden;\n}\n\n.table-container {\n  @apply w-full h-fit max-h-fit;\n}\n\n.ant-pagination .ant-pagination-item-active {\n  @apply bg-gray-50 border-none flex items-center;\n\n  a {\n    @apply text-gray-800 font-medium ml-1.5;\n  }\n}\n\n.ant-table-wrapper .ant-table-pagination {\n  a {\n    @apply text-gray-600 font-medium;\n  }\n}\n\n.ant-spin-nested-loading > div > .ant-spin {\n  background-color: white !important;\n}\n.custom-pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.custom-pagination .ant-pagination-total-text {\n  order: -1;\n  margin-right: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
